var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.56 21.32v-9.5m0 0a3.48 3.48 0 0 1-3.53-3.43 3.48 3.48 0 0 1 3.53-3.42m0 6.85a3.48 3.48 0 0 0 3.53-3.43 3.48 3.48 0 0 0-3.53-3.42m0-2.29v2.29M7.44 2.68v9.5m0 0a3.48 3.48 0 0 0-3.53 3.43 3.48 3.48 0 0 0 3.53 3.42m0-6.85a3.48 3.48 0 0 1 3.53 3.43 3.48 3.48 0 0 1-3.53 3.42m0 2.29v-2.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingB);
export default __webpack_public_path__ + "static/media/setting_b.733481d25e89a913a919b90ee708872d.svg";
export { ForwardRef as ReactComponent };